import React, { useEffect, useRef } from "react";

// Should not be used often. Last resort
export function useOnInit(callback: VoidFunction): void {
  const referencedRun = useRef(callback);
  useEffect(() => {
    referencedRun.current();
  }, []);
}
